import { Link } from "react-router-dom";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

export type CardProps = {
  image?: string;
  title: string;
  type?: string;
  link: string;
  children?: React.ReactNode;
};

const BrokenImage = "/dhi.png";

const Card: React.FC<CardProps> = ({ image, title, type, link, children }) => {
  const imageOnError = (event: React.SyntheticEvent<HTMLImageElement>) => {
    event.currentTarget.src = BrokenImage;
    event.currentTarget.className =
      "object-cover w-full h-full rounded-t-lg bg-gray-100 dark:bg-gray-800";
  };

  return (
    <div className="relative flex flex-col max-w-2xl w-full mx-auto rounded-xl shadow-lg overflow-hidden transition-transform duration-300 hover:scale-105 group bg-base-100 text-base-content">
      {/* Image on top */}
      <div className="w-full aspect-[16/9] overflow-hidden">
        <img
          src={image ? image : BrokenImage}
          onError={imageOnError}
          alt={title || "News Thumbnail"}
          className="object-cover w-full h-full transition-transform duration-300 group-hover:scale-105"
        />
        {/* Floating badge */}
        {type && (
          <span className="absolute top-4 left-4 bg-gradient-to-r from-blue-500 to-blue-700 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg">
            {type}
          </span>
        )}
      </div>
      {/* Text Section */}
      <div className="flex flex-col justify-between p-4 w-full">
        <div>
          <h3 className="text-lg font-bold mb-1 line-clamp-2">
            <Link to={link} className="hover:underline">
              {title}
            </Link>
          </h3>
          <p className="mb-4 line-clamp-3 text-base-content/70">
            Berita terbaru dari Divhubinter Polri. Klik tombol di bawah untuk
            membaca selengkapnya.
          </p>
        </div>
        <div>
          <Link
            to={link}
            className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-500 to-blue-700 text-white px-5 py-2 rounded-full font-semibold shadow hover:from-blue-700 hover:to-blue-500 transition"
          >
            Read More <FontAwesomeIcon icon={faArrowRight} />
          </Link>
        </div>
        {children}
      </div>
    </div>
  );
};

export default Card;
